import { useCallback, useMemo } from 'react';
import { CoreHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { PopupMenuItem } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { useServiceResponse } from '@store';
import { Country } from '@api/izibizi-xp';
import { useLogger } from '@hooks';

interface BuildPhoneCodesOutput {
	phoneCodes: PopupMenuItem[];
	initialPhone?: Country;
	initialPhoneId?: number;
	getSelectedPhone: (content: string) => Country;
}

interface BuildPhoneCodesInput {
	initialCountry?: string;
}

export const useBuildPhoneCodes = (props: BuildPhoneCodesInput): BuildPhoneCodesOutput => {
	const { retrieveCountries } = useServiceResponse();
	const logger = useLogger();
	const { initialCountry = 'PT' } = props;

	const phoneCodes = useMemo(() => {
		const indicatives = !CoreHelper.isNullOrEmpty(retrieveCountries?.countries) ? retrieveCountries?.countries : [];
		const result: PopupMenuItem[] | undefined = indicatives?.map((phoneCode) => {
			return {
				content: phoneCode.phonePrefix || '',
			};
		});
		logger('useBuildPhoneCodes >', {
			retrieveCountries: retrieveCountries,
			IsNullOrEmpty: CoreHelper.isNullOrEmpty(retrieveCountries?.countries),
			indicatives: indicatives,
			result: result,
			resultFilter: result?.filter((x) => x.content !== ''),
		});
		return result ? result.filter((x) => x.content !== '') : []; // filter phonePrefix is empty
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const initialPhone = retrieveCountries?.countries?.filter((phone) => phone.code === initialCountry)[0];
	const initialPhoneId = phoneCodes.findIndex((phone) => phone.content === initialPhone?.phonePrefix);

	const getSelectedPhone = useCallback((phoneCodeSelected: string) => {
		let country: Country = {};
		if (!CoreHelper.isNullOrEmpty(retrieveCountries?.countries)) {
			country = retrieveCountries?.countries?.filter(
				(phone) => phone.phonePrefix === phoneCodeSelected
			)[0] as Country;
		}
		return country;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		phoneCodes,
		initialPhone,
		initialPhoneId,
		getSelectedPhone,
	};
};
